import ZkButtonGroup from '../button/src/button-group';

/* istanbul ignore next */
ZkButtonGroup.install = function(Vue) {
  Vue.component(ZkButtonGroup.name, ZkButtonGroup);
};

export default ZkButtonGroup;



// WEBPACK FOOTER //
// ./src/packages/button-group/index.js